import { Outlet } from "react-router-dom";

const MainEstimation = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainEstimation;